module.exports = __webpack_public_path__ + "img/21_8.704f895d.png";